import _ from 'lodash';
import React from 'react'
import { combineClassNames } from '../../../helpers'
import Carousel from '../../carousel'
import useStyles from './content-group-style'

function TemplateBanner3Col(props) {
  const {
    contentGroup,
    onClickTrackEvent,
    template,
    configOptions,
  } = props
  const { contentGroupLines } = contentGroup
  const { row, col, imageBoxThreeImage } = useStyles()
  const onClick = (label) => {
    onClickTrackEvent(template, label)
  }
  return (
    <div className={combineClassNames([row, _.get(configOptions, 'htmlClass')])}>
      <div className={col}>
        <Carousel
          autoplay
          images={contentGroupLines}
          slidesToShowDesktop={3}
          slidesToShowMobile={1}
          imageBoxClassName={imageBoxThreeImage}
          marginCarousel="0"
          marginCarouselDesktop="0"
          postionDots={-15}
          darkDots
          onClick={onClick}
        />
      </div>
    </div>
  )
}

export default TemplateBanner3Col
